import { render, staticRenderFns } from "./preview-details.vue?vue&type=template&id=3ef581f1"
import script from "./preview-details.vue?vue&type=script&lang=js"
export * from "./preview-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports